/**
 * Custom SVG icons for Decideur profile types
 * Simple, modern, and brand-aligned designs
 */

interface IconProps {
  className?: string;
  color?: string;
}

// Icon for Cooperatives - Building with people
export function CooperativeIcon({ className = "w-12 h-12", color = "#55BC8C" }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Building structure */}
      <rect x="25" y="35" width="50" height="50" fill={color} rx="3" opacity="0.2" />
      <rect x="30" y="40" width="40" height="45" fill="white" stroke={color} strokeWidth="2.5" rx="2" />

      {/* Windows */}
      <rect x="37" y="48" width="8" height="8" fill={color} rx="1" opacity="0.6" />
      <rect x="55" y="48" width="8" height="8" fill={color} rx="1" opacity="0.6" />
      <rect x="37" y="60" width="8" height="8" fill={color} rx="1" opacity="0.6" />
      <rect x="55" y="60" width="8" height="8" fill={color} rx="1" opacity="0.6" />

      {/* Door */}
      <rect x="44" y="72" width="12" height="13" fill={color} rx="1" />

      {/* Roof */}
      <polygon points="25,40 50,25 75,40" fill={color} opacity="0.8" />
    </svg>
  );
}

// Icon for Négoces - Shopping/Commerce
export function NegoceIcon({ className = "w-12 h-12", color = "#55BC8C" }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Store front */}
      <rect x="20" y="40" width="60" height="45" fill={color} rx="3" opacity="0.15" />
      <rect x="25" y="45" width="50" height="40" fill="white" stroke={color} strokeWidth="2.5" rx="2" />

      {/* Awning */}
      <path d="M 22 45 L 78 45 L 75 38 L 25 38 Z" fill={color} opacity="0.7" />
      <line x1="35" y1="38" x2="35" y2="45" stroke={color} strokeWidth="1.5" />
      <line x1="50" y1="38" x2="50" y2="45" stroke={color} strokeWidth="1.5" />
      <line x1="65" y1="38" x2="65" y2="45" stroke={color} strokeWidth="1.5" />

      {/* Window displays */}
      <rect x="30" y="52" width="15" height="15" fill={color} rx="1" opacity="0.3" />
      <rect x="55" y="52" width="15" height="15" fill={color} rx="1" opacity="0.3" />

      {/* Door */}
      <rect x="42" y="70" width="16" height="15" fill={color} rx="1" />
      <circle cx="55" cy="77.5" r="1.5" fill="white" />
    </svg>
  );
}

// Icon for Instituts Techniques - Research/Laboratory
export function InstitutIcon({ className = "w-12 h-12", color = "#55BC8C" }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Lab flask */}
      <path
        d="M 40 25 L 40 45 L 30 70 Q 30 80 50 80 Q 70 80 70 70 L 60 45 L 60 25 Z"
        fill="white"
        stroke={color}
        strokeWidth="2.5"
      />
      <path
        d="M 40 25 L 40 45 L 30 70 Q 30 80 50 80 Q 70 80 70 70 L 60 45 L 60 25 Z"
        fill={color}
        opacity="0.15"
      />

      {/* Liquid inside */}
      <path
        d="M 35 65 Q 35 72 50 72 Q 65 72 65 65 L 58 50 L 42 50 Z"
        fill={color}
        opacity="0.5"
      />

      {/* Bubbles */}
      <circle cx="45" cy="58" r="2" fill={color} opacity="0.7" />
      <circle cx="52" cy="63" r="2.5" fill={color} opacity="0.7" />
      <circle cx="58" cy="56" r="1.5" fill={color} opacity="0.7" />

      {/* Flask neck */}
      <rect x="40" y="20" width="20" height="5" fill={color} rx="1" />
      <line x1="38" y1="25" x2="62" y2="25" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

// Icon for Chambres d'Agriculture - Government/Institution
export function ChambreIcon({ className = "w-12 h-12", color = "#55BC8C" }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Institutional building with columns */}
      <rect x="20" y="60" width="60" height="25" fill={color} rx="2" opacity="0.2" />

      {/* Roof/Pediment */}
      <polygon points="15,60 50,30 85,60" fill={color} opacity="0.8" />
      <rect x="15" y="58" width="70" height="4" fill={color} />

      {/* Columns */}
      <rect x="25" y="62" width="8" height="23" fill="white" stroke={color} strokeWidth="2" rx="1" />
      <rect x="46" y="62" width="8" height="23" fill="white" stroke={color} strokeWidth="2" rx="1" />
      <rect x="67" y="62" width="8" height="23" fill="white" stroke={color} strokeWidth="2" rx="1" />

      {/* Base */}
      <rect x="15" y="85" width="70" height="5" fill={color} />

      {/* Wheat symbol on pediment */}
      <line x1="50" y1="42" x2="50" y2="52" stroke={color} strokeWidth="2" strokeLinecap="round" opacity="0.6" />
      <circle cx="48" cy="45" r="1.5" fill={color} opacity="0.6" />
      <circle cx="52" cy="45" r="1.5" fill={color} opacity="0.6" />
      <circle cx="48" cy="49" r="1.5" fill={color} opacity="0.6" />
      <circle cx="52" cy="49" r="1.5" fill={color} opacity="0.6" />
    </svg>
  );
}
